import { Type } from "@angular/core";
import { InfoPlanCommand } from "src/app/shared/commands/info-plan-command";
import { OpenDetailCommand } from "src/app/shared/commands/open-detail-command";
import { DetailButtonComponent } from "src/app/shared/table-components/detail-button/detail-button.component";
import { CLOSE_RECOVERY_PLAN_DIALOG_CONFIG } from "../../../../services/close-recovery-plan-dialog-config";
import { DELETE_RECOVERY_PLAN_DIALOG_CONFIG } from "../../../../services/delete-recovery-plan-dialog-config";
import { RecoveryPlanService } from "../../../../services/recovery-plan.service";
import { ClosePlanCommand } from "../../../../shared/commands/close-plan-command";
import { DownloadExcelCommand } from "../../../../shared/commands/download-excel-command";
import { EditPlanCommand } from "../../../../shared/commands/edit-plan-command";
import { ConfirmDialogComponent } from "../../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { ActionCol } from "../../../../shared/table-col-configs/action-col";
import { ActionButtonsComponent } from "../../../../shared/table-components/action-buttons/action-buttons.component";
import { CheckboxComponent } from "../../../../shared/table-components/checkbox/checkbox.component";
import { DeleteCommand } from "../../../records/commands/delete-command";
import { TextCol } from "../../../records/models/columns/text-col";
import { TableStructure } from "../../../records/models/table-structure";
import { RecoveryPlan } from "./recovery-plan";

export const genRecoveryPlanTableConfig = (rpService: RecoveryPlanService) => {
  const RECOVERY_TABLE_CONFIG: TableStructure<RecoveryPlan> = new TableStructure<RecoveryPlan>(
    [
      new ActionCol<any, Type<DetailButtonComponent<any>>, RecoveryPlanService>(
        "surveyRequestId",
        true,
        undefined,
        [new OpenDetailCommand()],
        DetailButtonComponent
      ),
      new TextCol("brandId", false, "hotAlertTable.brand", undefined, true),
      new TextCol("marketId", undefined, "hotAlertTable.market"),
      new TextCol("dealerId", undefined, "recoveryPlanTable.dealer"),
      new TextCol("dealerName", undefined, "recoveryPlanTable.dealerName"),
      new TextCol("title", undefined, "recoveryPlanTable.title"),
      new TextCol("vin", true, "recoveryPlanTable.vin"),
      new TextCol("fullName", true, "recoveryPlanTable.customerName"),
      new TextCol("completedDate", undefined, "recoveryPlanTable.completedDate"),
      new TextCol("dateStart", false, "recoveryPlanTable.dateStart", "dd/MM/YYYY"),
      new TextCol("dateEnd", false, "recoveryPlanTable.dateEnd", "dd/MM/YYYY"),
      new TextCol("hotAlertClosingTime", false, "recoveryPlanTable.hotAlertClosingTime", undefined,undefined,undefined,undefined, false),
      new TextCol("status", undefined, "recoveryPlanTable.status",undefined,true),

      new ActionCol<RecoveryPlan, Type<CheckboxComponent<RecoveryPlan>>, RecoveryPlanService>(
        "closeAction",
        false,
        "close",
        [
          new ClosePlanCommand<RecoveryPlan, RecoveryPlanService>(
            rpService,
            ConfirmDialogComponent,
            CLOSE_RECOVERY_PLAN_DIALOG_CONFIG
          ),
        ],
        CheckboxComponent,
        false
      ),
      new ActionCol<RecoveryPlan, Type<ActionButtonsComponent<RecoveryPlan>>, RecoveryPlanService>(
        "infoAction",
        false,
        "info",
        [new InfoPlanCommand<RecoveryPlan, RecoveryPlanService>(rpService)],
        ActionButtonsComponent,
        false
      ),
      new ActionCol<RecoveryPlan, Type<ActionButtonsComponent<RecoveryPlan>>, RecoveryPlanService>(
        "deleteAction",
        false,
        "delete",
        [
          new DeleteCommand<RecoveryPlan, RecoveryPlanService>(
            rpService,
            ConfirmDialogComponent,
            DELETE_RECOVERY_PLAN_DIALOG_CONFIG
          ),
        ],
        ActionButtonsComponent,
        false
      ),

      new ActionCol<RecoveryPlan, Type<ActionButtonsComponent<RecoveryPlan>>, RecoveryPlanService>(
        "editAction",
        false,
        "edit",
        [new EditPlanCommand<RecoveryPlan, RecoveryPlanService>(rpService)],
        ActionButtonsComponent,
        false
      ),

    ],
    "serverSide",
    [10, 20, 30],
    undefined,
    false,
    [
      new DownloadExcelCommand<RecoveryPlan, RecoveryPlanService>(rpService),
      // new PrintCommand<RecoveryPlan, RecoveryPlanService>(),
      /*  new CreateRecoveryPlanCommand<RecoveryPlan, RecoveryPlanService>(
        "CREATE"
      ), */
    ]
  );

  return RECOVERY_TABLE_CONFIG;
};
